import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { type IncidentDto, type IncidentNote } from '@api/incidents';

import { IncidentNotesComponent } from '../incident-notes';

@Component({
  imports: [MatDialogModule, IncidentNotesComponent],
  selector: 'avs-notes-dialog',
  templateUrl: './notes-dialog.component.html',
})
export class NotesDialogComponent {
  protected data = inject<{ incident: IncidentDto }>(MAT_DIALOG_DATA);
  protected notes = signal<IncidentNote[]>([]);
}
